/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */

//libraries
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// custom components
import Home from './components/Home';
import Head from 'components/Head';

// content
import HOME_PAGE_CONTENT, { SERVICE_DESCRIPTIONS, SERVICE_ICONS } from './content';

//selectors
import { selectProviderCriteria } from 'modules/ProviderCriteria/selectors';

// hooks
import useArticles from 'hooks/useArticles';
import useRealStories from 'hooks/useRealStories';
import useModal from 'hooks/useModal';

// utils
import { openPromotionalModal } from 'utils/openPromotionalModal';

// api
import api from './api';

const HomePageContainer = (): JSX.Element => {
  const history = useHistory();

  const { services } = useSelector(selectProviderCriteria);

  const { articles, handleRelatedArticleClick } = useArticles({ forHomePage: true });

  const { isStoriesLoading, stories, handleStoryClick } = useRealStories({ forHomePage: true });

  const { handleModalOpen } = useModal();

  const [providerConnections, setProviderConnections] = useState([]);

  const [instagramMedia, setInstagramMedia] = useState([]);

  const [isProviderConnectionsLoading, setIsProviderConnectionsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      setIsProviderConnectionsLoading(true);
      try {
        const instagramMedia = await api.getInstagramMedia();
        setInstagramMedia(instagramMedia.data.data);
      } catch (err) {
        console.log(err);
      }
      try {
        const providerConnections = await api.getMainPageConnection();

        setProviderConnections(providerConnections.data);
      } catch (err) {
        console.log(err);
      }
      setIsProviderConnectionsLoading(false);
    })();
    // Show Promotional Modal on page load
    openPromotionalModal(handleModalOpen);
  }, []);

  const handleRedirectToServiceLanding = useCallback(
    (service: any) => (): void => {
      history.push(`/service/${service?.value?.split(' ').join('-').toLowerCase()}`);
    },
    [history],
  );

  const handleProviderConnectionClick = useCallback(
    (providerSlug: string) => (): void => {
      // @ts-ignore
      gtag('event', 'Provider Click', {
        event_category: 'Home',
        event_label: `${providerSlug}`,
      });
      history.push(`/maternal-specialist/${providerSlug}`);
    },
    [history],
  );

  const getPropertyFromList = (key: any, list: any) => list[key];

  const cardServices = useMemo(
    () =>
      services.map(({ id, value }: any) => {
        if (id === 'ProviderServiceOffered:9a68a32a-2ef6-4eb5-a444-78bf32e1cd6e') {
          return {
            id,
            value: 'Coaching',
            description: getPropertyFromList('Coaching', SERVICE_DESCRIPTIONS),
            src: getPropertyFromList('Coaching', SERVICE_ICONS),
          };
        } else {
          return {
            id,
            value,
            description: getPropertyFromList(value, SERVICE_DESCRIPTIONS),
            src: getPropertyFromList(value, SERVICE_ICONS),
          };
        }
      }),
    [services],
  );

  return (
    <>
      <Head
        title="New Parents, Parental Wellness Specialists | Robyn"
        slug=""
        description="Everyone has a unique path to parenthood. From fertility through early parenthood, we're here to help aspiring, expecting & new parents find support."
      />
      <Home
        articles={articles}
        stories={stories}
        providerConnections={providerConnections}
        onRelatedArticleClick={handleRelatedArticleClick}
        onStoryClick={handleStoryClick}
        homePageContent={HOME_PAGE_CONTENT}
        cardServices={cardServices}
        handleRedirectToServiceLanding={handleRedirectToServiceLanding}
        isProviderConnectionsLoading={isProviderConnectionsLoading}
        isStoriesLoading={isStoriesLoading}
        onProviderConnectionClick={handleProviderConnectionClick}
        instagramMedia={instagramMedia}
      />
    </>
  );
};

export default HomePageContainer;
